<template>
   <div id="language">
       <div class="tos">
          <el-form :inline="true" :model="guidanceQueryDto" label-width="100px"  class="demo-form-inline">
             <el-form-item label="关键字：">
               <el-select v-model="guidanceQueryDto.position" clearable placeholder="请选择引导语位置">
                     <el-option
                        v-for="item in ydyoptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                     </el-option>
                  </el-select>
             </el-form-item>
             <el-form-item>
                <el-button type="primary" plain @click="sjhsearchFor()">查询</el-button>
             </el-form-item>
          </el-form>
          <el-button class="right-item"  type="primary" @click=newoks()>添加引导语</el-button>
       </div>
       <div class="tableform">
         <el-table
             :data="tableData"
             border
             stripe
             :cell-style="{'text-align':'center'}"
             :header-cell-style="{'background-color': '#eef1f6','text-align':'center'}"
             style="width: 100%">
             <el-table-column
                prop="position"
                label="引导语位置"
                >
                <template slot-scope="{row:{ position }}">
                {{ position|| "—" }}
                </template>
             </el-table-column>
             <el-table-column
                prop="guidanceContent"
                label="引导语内容"
                show-overflow-tooltip
                >
                <template slot-scope="{row:{ guidanceContent }}">
                {{ guidanceContent|| "—" }}
                </template>
             </el-table-column>
             <el-table-column
                prop="remark"
                label="备注"
                >
                <template slot-scope="{row:{ remark }}">
                {{ remark|| "—" }}
                </template>
             </el-table-column>
             <el-table-column fixed="right" label="操作" width="280">
                <template slot-scope="scope">
                     <i title="编辑" class="el-icon-alixiugai" style="color: #1296db;cursor: pointer;"  @click=bianjiClick(scope.row) ></i>
                     <i title="删除" class="el-icon-alishanchu" style="color: #d81e06;cursor: pointer;"  @click=dels(scope.row) ></i>
                </template>
             </el-table-column>
          </el-table>
          <div class="btnbox">
             <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="guidanceQueryDto.pageNum"
                :page-sizes="[10, 15, 20]"
                :page-size="guidanceQueryDto.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="this.totals">
             </el-pagination>
          </div>
       </div>
       <!-- 添加引导语弹框 -->
       <el-dialog title="添加引导语" :visible.sync="increase" width="32%" class="zcyhtk"  @close='closeDialog'>
            <el-form ref="guidanceDto" :model="guidanceDto" :rules="zcrules" label-width="80px" label-position="right" size="small">
                <el-form-item label="引导语位置：" prop="position">
                  <el-select v-model="guidanceDto.position" placeholder="请选择引导语位置">
                     <el-option
                        v-for="item in ydyoptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                     </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="引导语内容：" prop="guidanceContent">
                    <el-input v-model="guidanceDto.guidanceContent" placeholder="请输入引导语内容"></el-input>
                </el-form-item>
                <el-form-item label="备注信息：">
                    <el-input v-model="guidanceDto.remark" placeholder="请输入备注"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="increase = false">取 消</el-button>
                <el-button type="primary"  @click="submitForm('guidanceDto',guidanceDto)">确 定</el-button>
            </div>
       </el-dialog>
       <!-- 修改弹框 -->
       <el-dialog title="修改" :visible.sync="dialogFormVisible" width="32%" class="zcyhtk"  @close='closeDialog'>
         <el-form ref="guidanceDto" :model="guidanceDto" :rules="zcrules" label-width="80px" label-position="right" size="small">
                <el-form-item label="引导语位置：" prop="position">
                  <el-select v-model="guidanceDto.position" placeholder="请选择引导语位置">
                     <el-option
                        v-for="item in ydyoptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                     </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="引导语内容：" prop="guidanceContent">
                    <el-input v-model="guidanceDto.guidanceContent" placeholder="请输入引导语内容"></el-input>
                </el-form-item>
                <el-form-item label="备注信息：">
                    <el-input v-model="guidanceDto.remark" placeholder="请输入备注"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="xgtkdfdqx">取 消</el-button>
                <el-button type="primary"  @click="submitForm('guidanceDto',guidanceDto)">确 定</el-button>
            </div>
       </el-dialog>
   </div>
   </template>
   <script>
      export default {
      name:'language',
      data(){
       return{
          guidanceQueryDto:{
             pageNum:1,
             pageSize:10,
             position:null,
             status:0,
          },
          tableData: [],
          totals:10,
          increase:false,
          dialogFormVisible:false,
          guidanceDto:{
            position:'',
            status:0,
            guidanceContent:'',
            remark:'',
            guidanceId:null,
            
         },
         ydyoptions: [],
         zcrules: {
            position: [
            { required: true, message: '请选择引导语位置', trigger: 'blur' },
            // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
            ],
            guidanceContent: [
            { required: true, message: '请输入引导语内容', trigger: 'blur' },
            // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
            ],
         },
       }
      },
      created(){
       this.getlist(this.guidanceQueryDto)
       this.ydyoptionslist()
      },
      mounted(){
      },
      methods:{
      ydyoptionslist(){
         this.ydyoptions=[{
            value: 0,
            label: '首页'
         }, {
            value: 1,
            label: '产品'
         }, {
            value: 2,
            label: '订单'
         }, {
            value: 3,
            label: '我的'
         }]
      },
       getlist(guidanceQueryDto) {
          this.$api.ydyqueryPage(guidanceQueryDto)
          .then((res) => {
                if (res.data.code == 200) {
                  this.tableData = res.data.data.records
                  this.tableData.forEach(element => {
                     if (element.position == 0) {
                        element.position = '首页'
                     }else if (element.position == 1) {
                        element.position = '产品'
                     }else if (element.position == 2) {
                        element.position = '订单'
                     }else if (element.position == 3) {
                        element.position = '我的'
                     }
                  });
                  this.totals = res.data.data.total
               } else {
               this.$message.error(res.data.message)
               }
          })
       },
       sjhsearchFor(){
         this.getlist(this.guidanceQueryDto)
       },
       submitForm(formName){
         this.$set(this.guidanceDto, 'status', 0);
         this.$refs[formName].validate((valid) => {
            if (valid) {
                this.$api.operatorGuidance(this.guidanceDto).then((res) => {
                if (res.data.code == 200) {
                    this.increase = false
                    this.dialogFormVisible = false
                    this.guidanceDto={
                        position:'',
                        status:0,
                        guidanceContent:'',
                        remark:'',
                        guidanceId:null,
                    }
                    this.getlist(this.guidanceQueryDto)
                    this.$message.success(res.data.message)
                } else {
                  this.$message.error(res.data.message)
                }
              })
            } 
          });
      },
      bianjiClick(row) {
         this.guidanceDto.guidanceId = row.guidanceId
         this.dialogFormVisible = true;
         this.bjtsClick(row.guidanceId)
      },
      bjtsClick(guidanceId){
         this.$api.ydyscqueryDetail({
               guidanceId:guidanceId
            }).then((res)=>{
               if (res.data.code == 200) {
                  this.guidanceDto = res.data.data
                  } else {
                     this.$message.error(res.data.message)
                  }
            })
      },
      dels(e) {
          this.$confirm('是否确认删除?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$api.ydydelete({
               guidanceId:e.guidanceId
                }).then((res) => {
                  if(res.data.code==200){
                     this.getlist(this.guidanceQueryDto)
                     this.$message.success(res.data.message)
                  }else{
                     this.$message.error(res.data.message)
                  }
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              });          
            });
        },
       newoks() {
         this.increase = true
      },
      closeDialog(){
        this.xgtkdfdqx()
      },
      xgtkdfdqx(){
        this.dialogFormVisible = false;
        this.guidanceDto={
            position:'',
            status:0,
            guidanceContent:'',
            remark:'',
            guidanceId:null,
         }
      },
      handleCurrentChange(val) {
         this.guidanceQueryDto.pageNum = val
          this.getlist(this.guidanceQueryDto)
      },
      handleSizeChange(val) {
         this.guidanceQueryDto.pageSize = val
          this.getlist(this.guidanceQueryDto)
      },
      }
      }
   </script>
   <style scoped>
#language {
   width: 100%;
   height: 100%;
   overflow-y: auto;
   background-color: #fff;
   padding:0 0 0 30px;
   box-sizing: border-box;
}
.tos {
   display: flex;
   /* justify-content: space-between; */
   align-items: center;
   /* background: yellow; */
   margin-bottom: 20px;
   margin-left: -30px;
 }
 .elrow{
   box-sizing: border-box;
   width: 20%;
   margin-top: -6px;
   margin: 0 40px 0 20px;
 }
 .elrowleft{
   width: 80%;
   float: left;
   box-sizing: border-box;
 }
 .elrowleft input{
   border: 2px solid #1b93ed !important;
   border-radius: 0 !important;
   width: 100%;
   -webkit-appearance: none;
   appearance: none;
   background-color: #fff;
   background-image: none;
   border-radius: 4px;
   border: 1px solid #929da5;
   box-sizing: border-box;
   color: #1f3d35;
   font-size: 14px;
   height: 36px;
   line-height: 1;
   outline: none;
   padding: 3px 10px;
   transition: border-color .2s cubic-bezier(.645,.045,.355,1);
 }
 .elrowcontent{
   width: 16.66667%;
   float: left;
   box-sizing: border-box;
 }
 .search-btn {
   height: 36px;
   width: 100px;
   background: #1b93ed;
   border: 2px solid #1b93ed;
   margin: 0;
   padding: 0;
   color: #fff;
   cursor: pointer;
 }
 .right-item {
   margin-left: auto; /* Pushes the item to the right */
 }
 .tos /deep/ .el-form-item {
     margin-bottom: 0 !important;
 }
 .btnbox {
   /* background: pink; */
   display: flex;
   width: 40%;
   align-items: center;
   justify-content: space-around;
   margin: auto;
   margin-top: 30px;
}
.zcyhtk /deep/ .el-form-item__label {
   width: 120px !important;
}
.zcyhtk /deep/ .el-form-item__content {
   margin-left: 120px !important;
}
   </style>


// WEBPACK FOOTER //
// src/components/marketivities/language.vue